import { render, staticRenderFns } from "./DwgViewer.vue?vue&type=template&id=5037bb8c&scoped=true"
import script from "./DwgViewer.vue?vue&type=script&lang=js"
export * from "./DwgViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5037bb8c",
  null
  
)

export default component.exports